import * as React from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import useTranslatewrapper from "../useTranslateWrapper";

export default function DeletableChips(props) {
  const { chipKey, chipValue, deleteChip,options} = props;
  const {translate} = useTranslatewrapper();
  // const handleDelete = () => {
  //   deleteChip(chipKey);
  // };
  const menuItemDisplayMap = JSON.parse(sessionStorage.getItem('menuItemDisplayMap'));
let chipValueNew=""
  if((chipValue && chipValue!=="" && chipValue!=="-") && chipKey === "sampleSentDate"){
  chipValueNew= "Sample Sent Date. " + chipValue
  }
  if((chipValue && chipValue!=="" && chipValue!=="-") && chipKey === "receivedDate"){
    chipValueNew= "Received Date. " + chipValue
  }


  // const getChipNamebyId = (chipId) => {
  //   if (options) {
  //     const newValue = options?.filter((option) => {
  //       return option.id == chipId;
  //     });
  //     return newValue[0]?.label;
  //   }
  //   return "";
  // };
  const getName = (chipId)=>{
    return menuItemDisplayMap[chipId] || "";
  }
  return (
    <Stack direction="row" spacing={5} style={{ paddingRight: "5px", marginBottom: "10px" , flexWrap: 'wrap'}}>
      {chipKey === "stateIds"
        ? chipValue.length >= 0 &&
        Array.isArray(chipValue) &&
          chipValue[0] != null &&
          chipValue?.map((chipId) => (
            <Chip
              label={translate(getName(chipId).toLowerCase())}
              variant="outlined"
              color="primary"
              sx={{ height: "1.8rem !important" }}
              size="small"
              onDelete={() => deleteChip(chipKey, chipId)}
            />
          ))
        : chipValue &&
          chipValue !== "" &&
          chipValue !== "-" && (
            <Chip
              label={translate(chipValue.toLowerCase())}
              color="primary"
              variant="outlined"
              sx={{ height: "1.8rem !important" }}
              size="small"
              onDelete={() => deleteChip(chipKey, chipValue)}
            />
          )}
    </Stack>
  );
}
